import { REDUCERS } from '@/constants/reducers';

export function jugadores(state, action) {
    switch (action.type) {
        case REDUCERS.UPDATE_JUGADORES:
            return {
                ...state,
                jugadores: action.payload.jugadores || action.payload,
                jornadas: action.payload.jornadas || state.jornadas || [],
            };
        default:
            return state;
    }
}
